/*
 * Copyright (c) 2020. American Express Company
 */

// ours

export enum NetWorthType {
    ASSETS,
    DEBTS
}

export class NetWorthListModel {
    name: string;
    amount: number;
    detail: string;
    type: NetWorthType;
    key: string;
    onClick: () => void;
}
